"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomResponseOptionGroupToggle = exports.ToggleContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.ToggleContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n"])));
function CustomResponseOptionGroupToggle(props) {
    var checked = props.checked, className = props.className, disabled = props.disabled, label = props.label, labelInfo = props.labelInfo, onToggled = props.onToggled;
    return (react_1.default.createElement(exports.ToggleContainer, { className: "tws-multiple-toggle-container".concat(className ? " ".concat(className) : '') },
        label,
        react_1.default.createElement(aon_tws_common_ui_1.Tooltip, { id: label + '-tooltip', contentType: 'html', wrapper: 'div' },
            react_1.default.createElement(aon_tws_common_ui_1.TooltipContentWrapper, null, react_1.default.createElement("p", null, labelInfo))),
        react_1.default.createElement(aon_tws_common_ui_1.Switch, { style: { marginLeft: '5px' }, disabled: disabled, checked: checked, onChange: function (event) { return onToggled === null || onToggled === void 0 ? void 0 : onToggled(event.target.checked); } })));
}
exports.CustomResponseOptionGroupToggle = CustomResponseOptionGroupToggle;
var templateObject_1;
